import { SUBDIVISION, SYSTEM_ALERT } from '@gameday/common/constants/endpoints'

export default {
  subdivision: SUBDIVISION, // 'gamedayapi/common/subdivision',
  subdivisionDirect: 'common/subdivision',
  systemalert: SYSTEM_ALERT, // 'gamedayapi/common/systemalert'
}
